import { shallow } from 'zustand/shallow';

export function shallowCallback<T>(cb: (args: T) => void) {
  return function shallowCallback(args: T, prevArgs: T) {
    if (!shallow(args, prevArgs)) {
      cb(args);
    }
  };
}
